import { format, isValid, parseISO } from 'date-fns';

export function mapDateToApiDate(date: Date | undefined | null): string | null {
    return date && isValid(date) && !format(date, 'yyyy-MM-dd').startsWith('0') ? format(date, 'yyyy-MM-dd') : null;
}
export function mapDateToRequiredApiDate(date: Date): string {
    return format(date, 'yyyy-MM-dd');
}
export function mapDateStringToApiDate(date: string | undefined | null): string | null {
    try {
        if (!date) return null;
        const formatted = format(new Date(date), 'yyyy-MM-dd');
        return isValidDateString(formatted) ? formatted : null;
    } catch (e) {
        return null;
    }
}

function isValidDateString(value: string): boolean {
    return (
        /^([1-9]\d*-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))(([t|T]([0-9]{2}):([0-9]{2}):([0-9]{2}).[0-9]{3}[z|Z])?)$/.test(
            value,
        ) && isValid(parseISO(value))
    );
}
